import React from 'react';
import { useI18n } from '../../i18n/I18nProvider';


const UdemyCourse: React.FC<{ udemyUrl: string }> = ({ udemyUrl }) => {
  const { t } = useI18n();

  return (
    <section id='curso-udemy' className='py-16 bg-white'>
      <div className='flex flex-col gap-10 items-center px-8 mx-auto max-w-4xl md:flex-row'>
        <div className='flex-shrink-0'>
          <img
            src='/angular_logo.png'
            alt='Angular Moderno - Curso Udemy'
            className='object-contain mb-6 w-48 h-48 rounded-xl shadow-lg md:mb-0'
          />
        </div>
        <div className='flex-1 text-center md:text-left'>
          <h2 className='mb-4 font-bold text-gray-800 text-1xl md:text-1xl'>{t.sections.cursoUdemy.title}</h2>
          <p className='mb-6 text-lg text-gray-700'>{t.sections.cursoUdemy.description}</p>
          <ul className='mb-6 list-none list-inside text-gray-700'>
            {t.sections.cursoUdemy.features.map((feature, index) => (
              <li key={index} className='mb-2'>
                {feature}
              </li>
            ))}
          </ul>
          <div className='flex justify-center md:justify-center'>
            <a
              href={udemyUrl}
              target='_blank'
              rel='noopener noreferrer'
              className='inline-block px-10 py-4 text-xl font-semibold text-center text-white bg-gradient-to-r from-purple-600 to-pink-500 rounded-lg shadow transition hover:from-purple-700 hover:to-pink-600'
            >
              {t.sections.cursoUdemy.button}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UdemyCourse; 